import { atom } from 'jotai'

import { VariantConfig } from '../LineItemEditor'

export const lineItemEditorConfig = atom<VariantConfig | null>(null)
export const showAddLineItemGroupDropdownAtom = atom<boolean>(false)
